import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { useAuthState } from '@application/state';
import { graphql } from '@gql/gql';
import type { AccountNewNotificationsCountQuery } from '@gql/graphql';

export const ACCOUNT_GET_NEW_NOTIFICATIONS_COUNT = graphql(`
  query AccountNewNotificationsCount {
    newNotificationsCount
  }
`);

export const useNotificationsCount = () => {
  const { currentAccountLoggedIn } = useCurrentAccount();
  const authState = useAuthState();
  const { data, error, loading, refetch } = useQuery<AccountNewNotificationsCountQuery>(
    ACCOUNT_GET_NEW_NOTIFICATIONS_COUNT,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      ssr: false,
      skip: !currentAccountLoggedIn || !authState.token,
    },
  );
  return {
    newNotificationsCount: data?.newNotificationsCount ?? 0,
    newNotificationsCountError: error,
    newNotificationsCountLoading: loading,
    refetchNewNotificationsCount: refetch,
  };
};
